module.exports = __webpack_public_path__ + "img/044-latvia.0b1b115d.svg";